import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import type { ResolvedProfileLocation } from '../../services/quickcam-coin-waitlist/resolve-profile-location';
import styles from './qcc-waitlist-dialog.module.scss';

export const WAITLIST_DISCLAIMER =
  'Direct purchase is not available for your account right now. Joining the waitlist registers interest only — it does not reserve coins, a price, allocation, or purchase priority.';

export const WAITLIST_ACTIVE_COPY =
  'You will need to recheck availability before any future purchase. Notifications are optional and do not guarantee eligibility.';

export const WAITLIST_REGION_TITLE =
  'QuickCam Coin Is Not Available In Your Region';

type QccWaitlistDialogProps = {
  open: boolean;
  variant: 'join' | 'onWaitlist';
  profileLocation: ResolvedProfileLocation;
  busy: boolean;
  error: string | null;
  onClose: () => void;
  onJoin: () => void;
};

const QccWaitlistDialog: React.FC<QccWaitlistDialogProps> = ({
  open,
  variant,
  profileLocation,
  busy,
  error,
  onClose,
  onJoin,
}) => {
  const onWaitlist = variant === 'onWaitlist';
  const status = onWaitlist ? 'You are on the waitlist' : 'Waitlist open';
  const copy = onWaitlist ? WAITLIST_ACTIVE_COPY : WAITLIST_DISCLAIMER;

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      fullWidth
      maxWidth="sm"
      aria-labelledby="qcc-waitlist-dialog-title"
      PaperProps={{ className: styles.paper }}
    >
      <DialogContent className={styles.content}>
        <h2 id="qcc-waitlist-dialog-title" className={styles.title}>
          {WAITLIST_REGION_TITLE}
        </h2>
        <p className={styles.status}>{status}</p>
        <p className={styles.copy}>{copy}</p>
        <div className={styles.location}>
          <p className={styles.locationHeading}>Your Location:</p>
          <p>Country: {profileLocation.countryName || ''}</p>
          <p>State: {profileLocation.stateName || ''}</p>
          <p>City: {profileLocation.cityName || ''}</p>
        </div>
        {error && (
          <p className={styles.error} role="alert">
            {error}
          </p>
        )}
        <div className={styles.actions}>
          {onWaitlist ? (
            <button
              type="button"
              className={styles.button}
              onClick={() => onClose()}
            >
              Close
            </button>
          ) : (
            <>
              <button
                type="button"
                className={`${styles.button} ${styles.primary}`}
                disabled={busy}
                onClick={() => onJoin()}
              >
                <span className={`material-icons ${styles.icon}`} aria-hidden>
                  person_add
                </span>
                Join QuickCam Coin Waitlist
              </button>
              <button
                type="button"
                className={styles.button}
                disabled={busy}
                onClick={() => onClose()}
              >
                Cancel
              </button>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default QccWaitlistDialog;
